import React from "react";
import "./UserAvatar.css";
// import { Helmet } from "react-helmet";

function UserAvatar(props) {
  return (
    <div className={"teacher-avatar-box home-avatar"}>
      {/* <Helmet>
        <meta property="og:description" content="Share teacher profile" />
        <meta name="image" property="og:image" content={props.icon} />
      </Helmet> */}
      <div className="teacher-avatar-wrapper">
        <img
          src={props.icon || "../../assets/img/avatar.png"}
          //className={"user-avatar-img"}
            className="teacher-avatar-img"
          alt="user's avatar"
        />
      </div>
      {props.children}
    </div>
  );
}

export default UserAvatar;
